/**
 * Feed silo drawing in a 512 unit tall coordinate space, split into the part that holds feed (and is filled
 * to the current level) and the legs (never filled).
 */
export const feedSiloSvg = {
	viewBox: '140 0 232 512',
	/** Roof, cylindrical body and cone hopper with its outlet. */
	vessel: `
		M 246 0 L 266 0 L 266 12 L 364 98 L 364 108 L 356 108 L 356 330
		L 272 420 L 268 420 L 268 436 L 244 436 L 244 420 L 240 420 L 156 330
		L 156 108 L 148 108 L 148 98 L 246 12 Z
	`,
	/** Legs with feet and cross-bracing. */
	legs: `
		M 156 320 L 170 320 L 170 500 L 178 500 L 178 512 L 148 512 L 148 500 L 156 500 Z
		M 342 320 L 356 320 L 356 500 L 364 500 L 364 512 L 334 512 L 334 500 L 342 500 Z
		M 170 444 L 178 444 L 342 488 L 342 496 L 334 496 L 170 452 Z
		M 334 444 L 342 444 L 342 452 L 178 496 L 170 496 L 170 488 Z
	`,
	/** 0% full: the bottom of the hopper outlet. */
	fillBottom: 436,
	/** 100% full: the roof peak. */
	fillTop: 0,
};
